// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zmM8l","colMin":"styles_colMin__Pf8SI"};